import type { AppRoute } from "../../../App/Routes"

export function selectedShipId(route: AppRoute): number | undefined {
  if (route.route[0] != "ships") {
    return undefined;
  }
  const id = Number(route.route[1]);
  return Number.isInteger(id) && id > 0 ? id : undefined;
}
